import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { EmployeesDeptWiseCountDto, EmployeesDeptWiseResponseModel } from '@gtpl/shared-models/gtpl';
import { Repository, getConnection } from 'typeorm';
import { EmployeeDto } from './dto/employee.dto';
import { EmployeeResponseModel, AllEmployeesResponseModel } from '@gtpl/shared-models/gtpl';
import { EmployeeDetailsDTO } from './dto/employee-details.dto';
import { EmployeesAdapter } from './dto/employees-adapter';
import { EmployeeDetails } from './employee-details.entity';
import { UserEntity } from '../user/user.entity';
import { UserService } from '../user/user.service';
import { CommonResponse } from '@gtpl/shared-models/masters';
import { AttendanceService } from '@gtpl/shared-services/hrms';
import { GenericTransactionManager } from 'apps/services/backend/typeorm-transactions/generic-transaction-manager';
import { EmployeeCodesRequest } from '@gtpl/shared-models/hrms';

@Injectable()
export class EmployeeDetailsService {

  constructor(@InjectRepository(EmployeeDetails)
  private employeeDetailsRepository: Repository<EmployeeDetails>,
    // private projectMappingRepository: Repository<ProjectMapping>, 
    @InjectRepository(UserEntity)
    private userRepository: Repository<UserEntity>,
    private employeesAdapter: EmployeesAdapter,
    private userService: UserService,
    private attendanceService: AttendanceService
  ) { }

  //@LogActions({isAsync: true})
  async getAllEmployees(userid: number, role: string): Promise<AllEmployeesResponseModel> {
    const page: number = 1;
    // const response = new AllEmployeesResponseModel();
    try {
      const employeeDtos: EmployeeDetailsDTO[] = [];
      //retrieves all companies
      // const employeeEntities: EmployeeDetails[];
      // console.log('Employee service user id = '+userid);
      // const employee_id=await this.userService.getEmpid(userid);
      // console.log('employee_data'+employee_id)
      // if(role==='L2'|| role==='L3'){
      //  var projectMappingData = await this.projectMappingRepository.find({
      //   select: ['projectId'],
      //   where:{empId:employee_id}});
      //   const project_id_data:Number[]=[];
      //   projectMappingData.forEach(projectid=>{project_id_data.push(projectid.projectId); });
      //  console.log('Project ids = '+project_id_data);

      var employeeEntities: EmployeeDetails[] = await this.employeeDetailsRepository.find({
        order: { employeeName: 'ASC' }
      });
      // }

      // console.log(employeeEntities);
      if (employeeEntities) {
        // console.log(employeeEntities);
        //converts the data fetched from the database which of type companies array to type StateDto array.
        employeeEntities.forEach(employeesEntity => {
          // console.log(employeesEntity);
          const convertedemployeesDto: EmployeeDetailsDTO = this.employeesAdapter.convertEntityToDto(employeesEntity);
          employeeDtos.push(convertedemployeesDto);
        });
        const response = new AllEmployeesResponseModel(true, 1, 'Employees retrieved successfully', employeeDtos);
        return response;
      } else {
        throw new ErrorResponse(99998, 'enPmsLabels.errorCodes[99998]');
      }
    } catch (err) {
      throw err;
    }
  }

  async createEmployee(employeeDetailsDTO: EmployeeDetailsDTO, isUpdate: boolean, request: Request): Promise<EmployeeResponseModel> {
    const transManager = new GenericTransactionManager();
    // const response = new EmployeeResponseModel();
    try {
      // console.log(isUpdate); 
      //this section will be executed while creating a new user only
      if (!isUpdate) {
        console.log(isUpdate);

        const employeeEntity = await this.getEmployeeDetailsWithoutRelations(employeeDetailsDTO.employeeCode);
        // console.log(employeeEntity);
        if (employeeEntity) {
          // return true;
          throw new ErrorResponse(11104, 'Employee already exists');
        }
      }
      const req = new EmployeeCodesRequest([employeeDetailsDTO.employeeCode])
      // await transManager.startTransaction();
      const convertedEmployeesEntity: EmployeeDetails = this.employeesAdapter.convertDtoToEntity(employeeDetailsDTO, isUpdate);
      const savedEmployeeEntity: EmployeeDetails = await this.employeeDetailsRepository.save(convertedEmployeesEntity);
      const savedEmployeeDto: EmployeeDetailsDTO = this.employeesAdapter.convertEntityToDto(savedEmployeeEntity);
      // await this.attendanceService.createEmpAttendanceLogs(req);
      // await transManager.completeTransaction();
      if (savedEmployeeDto) {
        const response = new EmployeeResponseModel(true, 1, 'Employee saved successfully', savedEmployeeDto);
        return response;
      } else {
        // await transManager.releaseTransaction()
        throw new ErrorResponse(11106, 'Employee saved but issue while transforming into DTO');
      }
      // return response;
    }
    catch (error) {
      throw error;
    }
  }

  // @LogActions({isAsync: true})
  async getEmployeeDetailsWithoutRelations(employeeCode: string): Promise<EmployeeDetails> {
    //  console.log(employeeId);
    const employeeResponse = await this.employeeDetailsRepository.findOne({
      where: { employeeCode: employeeCode },
    });
    // console.log(employeeResponse);
    if (employeeResponse) {
      return employeeResponse;
    } else {
      return null;
    }
  }

  //@LogActions({isAsync: true})
  async getActiveEmployees(): Promise<AllEmployeesResponseModel> {
    const page: number = 1;
    // const response = new AllEmployeesResponseModel();
    try {
      const employeeDtos: EmployeeDetailsDTO[] = [];
      //retrieves all companies
      const employeeEntities: EmployeeDetails[] = await this.employeeDetailsRepository.find({
        where: { isActive: 1 }, order: { employeeName: 'ASC' }
      });
      // console.log(employeeEntities);
      if (employeeEntities) {
        // console.log(employeeEntities);
        //converts the data fetched from the database which of type companies array to type StateDto array.
        employeeEntities.forEach(employeesEntity => {
          // console.log(employeesEntity);
          const convertedemployeesDto: EmployeeDetailsDTO = this.employeesAdapter.convertEntityToDto(employeesEntity);
          employeeDtos.push(convertedemployeesDto);
        });
        //generated response
        const response = new AllEmployeesResponseModel(true, 1, 'Employees retrieved successfully', employeeDtos);
        return response;
      } else {
        throw new ErrorResponse(99998, 'enPmsLabels.errorCodes[99998]');
      }
      // return response;
    } catch (err) {
      throw err;
    }
  }

  //@LogActions({isAsync: true})
  async getActiveEmployeesByDept(deptId: number): Promise<AllEmployeesResponseModel> {
    const page: number = 1;
    // const response = new AllEmployeesResponseModel();
    try {
      const employeeDtos: EmployeeDetailsDTO[] = [];
      //retrieves all companies
      const employeeEntities: EmployeeDetails[] = await this.employeeDetailsRepository.find({
        where: { deptId: deptId, isActive: 1 }, order: { employeeName: 'ASC' }
      });
      // console.log(employeeEntities);
      if (employeeEntities) {
        // console.log(employeeEntities);
        //converts the data fetched from the database which of type companies array to type StateDto array.
        employeeEntities.forEach(employeesEntity => {
          // console.log(employeesEntity);
          const convertedemployeesDto: EmployeeDetailsDTO = this.employeesAdapter.convertEntityToDto(employeesEntity);
          employeeDtos.push(convertedemployeesDto);
        });
        //generated response
        const response = new AllEmployeesResponseModel(true, 1, 'Employees retrieved successfully', employeeDtos);
        return response;
      } else {
        throw new ErrorResponse(99998, 'enPmsLabels.errorCodes[99998]');
      }
      // return response;
    } catch (err) {
      throw err;
    }
  }

  async getActiveEmpDeptWiseCount(deptId: number): Promise<EmployeesDeptWiseResponseModel> {
    try {
      const employeeDtos: EmployeesDeptWiseCountDto[] = [];
      //retrieves all companies
      const empCount = await getConnection()
        .createQueryBuilder()
        .select("department_id as departmentId, count(*) as count")
        .from(EmployeeDetails, 'employee_details')
        .where(`department_id = ${deptId}`)
        .getRawOne();

      if (empCount) {
        return new EmployeesDeptWiseResponseModel(true, 11111, "", empCount);
      } else {
        throw new ErrorResponse(99998, 'enPmsLabels.errorCodes[99998]');
      }
    } catch (err) {
      throw err;
    }
  }

  // async getActiveEmpCount(): Promise<EmployeesStatusWiseResponseModel> {
  //   const page: number = 1;
  //   // const response = new EmployeesStatusWiseResponseModel();
  //   try {
  //     const employeeDtos: EmployeesStatusWiseCountDto[] = [];
  //     //retrieves all companies
  //     const empCount=await getConnection()
  //     .createQueryBuilder()
  //     .select("SUM(IF(status = true, 1, 0)) as activeempCount,SUM(IF(status = false, 1, 0)) as inactiveEmployeeCount")
  //     .from(EmployeeDetails, "EmployeeDetails")
  //     .orderBy('status','ASC')
  //     .getRawOne();

  //     if (response) {
  //       response.status = true;
  //       response.data = empCount.activeempCount;
  //       response.data1 = empCount.inactiveEmployeeCount;
  //       response.statusCode = 50000;
  //       response.internalMessage = 'Employees retrieved successfully';
  //       response.intlCode = 11108;
  //     } else {
  //       throw new ErrorResponse(99998, 'enPmsLabels.errorCodes[99998]');
  //     }
  //     return response;
  //   } catch (err) {
  //     throw err;
  //   }
  // }
  // async getTerminationCount(): Promise<EmployeesStatusWiseResponseModel> {
  //   const page: number = 1;
  //   const response = new EmployeesStatusWiseResponseModel();
  //   try {
  //     const employeeDtos: EmployeesStatusWiseCountDto[] = [];
  //     //retrieves all companies

  //     const terminatedCount=await getConnection()
  //     .createQueryBuilder()
  //     .select("SUM(IF(is_termination_approved= true, 1, 0)) as activeterminatedempCount,SUM(IF(is_termination_approved= false, 1, 0)) as inactiveTerminatedCount, count(*) as cnt")
  //     .from(EmployeeDetails, "EmployeeDetails")
  //     .where('status= true')
  //     .andWhere('is_terminated= true')
  //     .orderBy('status','DESC')
  //     .getRawOne();

  //     if (response) {
  //       response.status = true;
  //       response.data = terminatedCount.activeterminatedempCount;
  //       response.data1 = terminatedCount.inactiveTerminatedCount;
  //       response.total = terminatedCount.cnt;
  //       response.statusCode = 50000;
  //       response.internalMessage = 'Employees retrieved successfully';
  //       response.intlCode = 11108;
  //     } else {
  //       throw new ErrorResponse(99998, 'enPmsLabels.errorCodes[99998]');
  //     }
  //     return response;
  //   } catch (err) {
  //     throw err;
  //   }
  // }

  // async getTerminationApprovalCount(): Promise<EmployeesStatusWiseResponseModel> {
  //   const page: number = 1;
  //   const response = new EmployeesStatusWiseResponseModel();
  //   try {
  //     const employeeDtos: EmployeesStatusWiseCountDto[] = [];
  //     //retrieves all companies
  //     const terminationCount=await getConnection()
  //     .createQueryBuilder()
  //     .select("SUM(IF(is_termination_approved= true, 1, 0)) as approvedterminationCount, SUM(IF(is_termination_approved= false, 1, 0)) as pendingterminationCount, count(*) as totalTerminatedCount")
  //     .from(EmployeeDetails, "EmployeeDetails")
  //     .where('is_terminated= true')
  //     .orderBy('status','DESC')
  //     .getRawOne();

  //     if (response) {
  //       response.status = true;
  //       response.data = terminationCount.approvedterminationCount;
  //       response.data1 = terminationCount.pendingterminationCount;
  //       response.total = terminationCount.totalTerminatedCount;
  //       response.statusCode = 50000;
  //       response.internalMessage = 'Employees retrieved successfully';
  //       response.intlCode = 11108;
  //     } else {
  //       throw new ErrorResponse(99998, 'enPmsLabels.errorCodes[99998]');
  //     }
  //     return response;
  //   } catch (err) {
  //     throw err;
  //   }
  // }
  // // @LogActions({isAsync: true})
  // async getEmployeeById(Id: number): Promise<EmployeeResponseModel> {
  //   const response = new EmployeeResponseModel();
  //   try {
  //     const employeesResponse = await this.employeeDetailsRepository.findOne({
  //       where:{Id: Raw(alias =>`UPPER(id) = '${Id}'`)
  //       }
  //     });

  //     // console.log(employeesResponse);
  //     if (employeesResponse) {
  //       const convertedemployeesDto: EmployeeDetailsDTO = this.employeesAdapter.convertEntityToDto(
  //         employeesResponse);

  //       response.status = true;
  //       response.data = convertedemployeesDto;
  //       response.statusCode = 50000;
  //       response.internalMessage = 'Employees retrieved successfully';
  //       response.intlCode = 11108;
  //     } else {
  //       throw new ErrorResponse(99998, 'enPmsLabels.errorCodes[99998]');
  //     }
  //     return response;
  //   } catch (err) {
  //     throw err;
  //   }
  //   }

  //   // @LogActions({isAsync: true})
  // async getEmployeeByEmpCode(empCode: string): Promise<EmployeeResponseModel> {
  //   const response = new EmployeeResponseModel();
  //   try {
  //     const employeesResponse = await this.employeeDetailsRepository.findOne({ where: { empCode: Raw(alias =>`UPPER(emp_code) = '${empCode}'`)}, order: { empName: 'ASC' }
  //   });
  //     // console.log(employeesResponse);
  //     if (employeesResponse) {
  //       const convertedemployeesDto: EmployeeDetailsDTO = this.employeesAdapter.convertEntityToDto(
  //         employeesResponse)
  //       response.status = true;
  //       response.data = convertedemployeesDto;
  //       response.statusCode = 50000;
  //       response.internalMessage = 'Employees retrieved successfully';
  //       response.intlCode = 11108;
  //     } else {
  //       throw new ErrorResponse(99998, 'enPmsLabels.errorCodes[99998]');
  //     }
  //     return response;
  //   } catch (err) {
  //     throw err;
  //   }
  //   }


  //   async terminateEmployee(employeeDto: EmployeeDetailsDTO,request:Request):Promise<EmployeeResponseModel>{
  //     const response = new EmployeeResponseModel();
  //      try{
  //       const employeesResponse = await this.employeeDetailsRepository.update(employeeDto.Id,employeeDto);
  //       console.log(employeesResponse);
  //         const employeedetailsDto:EmployeeDetailsDTO[] = [];

  //         const employeeDetailsEntities: EmployeeDetails[] = await this.employeeDetailsRepository.find({
  //           where: { status: 1 },
  //           order: { createdAt: 'DESC' }
  //         });
  //         console.log(employeeDetailsEntities);
  //         if (employeeDetailsEntities) {

  //           employeeDetailsEntities.forEach(employeesEntity => {
  //             console.log(employeesEntity);
  //             const convertedemployeesDto: EmployeeDetailsDTO = this.employeesAdapter.convertEntityToDto(employeesEntity);
  //             employeedetailsDto.push(convertedemployeesDto);
  //           });

  //           response.status = true;
  //           // response.data = employeedetailsDto;
  //           response.statusCode = 50000;
  //           response.internalMessage = 'Employee retrieved successfully';
  //           response.intlCode = 11108;
  //         } 
  //         return response;
  //      }catch (error) {
  //        // tslint:disable-next-line: typedef
  //        throw error;
  //      }

  //    }

  //     //@LogActions({isAsync: true})
  //  async getTerminatedEmployees(): Promise<AllEmployeesResponseModel> {
  //   const page: number = 1;
  //   const response = new AllEmployeesResponseModel();
  //   try {
  //     const employeeDtos: EmployeeDetailsDTO[] = [];
  //     //retrieves all companies
  //     const employeeEntities: EmployeeDetails[] = await this.employeeDetailsRepository.find({
  //       where: { isTerminated: 1 },
  //       order: { isTerminationApproved: 'ASC', empName:'ASC' }
  //     });
  //     console.log(employeeEntities);
  //     if (employeeEntities) {
  //         // console.log(employeeEntities);
  //       //converts the data fetched from the database which of type companies array to type StateDto array.
  //       employeeEntities.forEach(employeesEntity => {
  //         // console.log(employeesEntity);
  //         const convertedemployeesDto: EmployeeDetailsDTO = this.employeesAdapter.convertEntityToDto(     employeesEntity);
  //         employeeDtos.push(convertedemployeesDto);
  //       });

  //       //generated response
  //       response.status = true;
  //       response.data = employeeDtos;
  //       response.statusCode = 50000;
  //       response.internalMessage = 'Employees retrieved successfully';
  //       response.intlCode = 11108;
  //     } else {
  //       throw new ErrorResponse(99998, 'enPmsLabels.errorCodes[99998]');
  //     }
  //     return response;
  //   } catch (err) {
  //     throw err;
  //   }
  // }

  // async approveEmployeeTermination(employeeDto: EmployeeDetailsDTO,request:Request):Promise<EmployeeResponseModel>{
  //   // console.log(employeeDto);
  //   const response = new EmployeeResponseModel();
  //    try{
  //     const employeesResponse = await this.employeeDetailsRepository.update(employeeDto.Id,employeeDto);
  //     // console.log(employeesResponse);
  //       const employeedetailsDto:EmployeeDetailsDTO[] = [];
  //         const employeeDetailsEntities: EmployeeDetails[] = await this.employeeDetailsRepository.find({
  //         where: { status: 1 },
  //         order: { createdAt: 'DESC' }
  //       });
  //       // console.log(employeeDetailsEntities);
  //       if (employeeDetailsEntities) {

  //         employeeDetailsEntities.forEach(employeesEntity => {
  //           // console.log(employeesEntity);
  //           const convertedemployeesDto: EmployeeDetailsDTO = this.employeesAdapter.convertEntityToDto(employeesEntity);
  //           employeedetailsDto.push(convertedemployeesDto);
  //         });
  //        //   //generated response
  //         response.status = true;
  //         // response.data = employeedetailsDto;
  //         response.statusCode = 50000;
  //         response.internalMessage = 'Employee retrieved successfully';
  //         response.intlCode = 11108;
  //       } else {
  //          throw new ErrorResponse(99998, 'enPmsLabels.errorCodes[99998]');
  //       }
  //       return response;
  //    }catch (error) {
  //      // tslint:disable-next-line: typedef
  //      throw error;
  //    }

  //  }

  async updateEmployeeStatus(employeeDto: EmployeeDto, request: Request): Promise<AllEmployeesResponseModel> {
    // const response = new AllEmployeesResponseModel();
    try {
      await this.employeeDetailsRepository.update(employeeDto.employeeId, employeeDto);
      const employeeDetailsDtos: EmployeeDetailsDTO[] = [];
      //retrieves all companies
      //  await this.statesRepository.save();
      const employeeEntities: EmployeeDetails[] = await this.employeeDetailsRepository.find({
        where: { status: 1 },
        order: { createdAt: 'DESC' }
      });
      if (employeeEntities) {
        // converts the data fetched from the database which of type companies array to type StateDto array.
        employeeEntities.forEach(employeeEntity => {
          // const convertedstatesDto: EmployeeDetailsDTO = this..convertEntityToDto(stateEntity);
          // employeeDetailsDtos.push(employeeEntity);
        });
        //generated response
        const response = new AllEmployeesResponseModel(true, 1, 'Employees retrieved successfully', employeeEntities);
        return response;
      } else {
        throw new ErrorResponse(99998, 'enPmsLabels.errorCodes[99998]');
      }
      // return response;
    } catch (error) {
      // tslint:disable-next-line: typedef
      throw error;
    }

  }
  async findEmp(empId: Number): Promise<any> {
    // console.log('findEmpAttendance');
    const empCount = await getConnection()
      .createQueryBuilder()
      .select("count(*)")
      .from(EmployeeDetails, "EmployeeDetails")
      .where("EmployeeDetails.id=" + empId)
      .getQuery();
    return empCount;
  }


  async updateDesignationForDesignationAction(employeeId: number, designation: string): Promise<CommonResponse> {
    try {

      const update = await this.employeeDetailsRepository.update({ employeeId: employeeId }, { designation: designation })
      if (update.affected) {
        return new CommonResponse(true, 11111, 'Designation updated in employees details')
      } else {

        return new CommonResponse(false, 1110, 'Error while updating designation in employee details ')
      }
    } catch (err) {
      return err
    }

  }
  async updateDepartmentForDesignationAction(employeeId: number, departmentId: string): Promise<CommonResponse> {
    try {
      console.log(employeeId, departmentId)
      const update = await this.employeeDetailsRepository.update({ employeeId: employeeId }, { departmentId: departmentId })
      if (update.affected) {
        return new CommonResponse(true, 11111, 'Department updated in employees details')
      } else {

        return new CommonResponse(false, 1110, 'Error while updating department in employee details ')
      }
    } catch (err) {
      return err
    }

  }



}
